import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import api from '../api';

// ── Official brand SVG icons ──────────────────────────────────────────────────

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/>
  </svg>
);

// Brand colours for each platform
const SOCIAL_CONFIG = [
  {
    key:     'social_telegram',
    label:   'Telegram',
    Icon:    TelegramIcon,
    bgColor: 'bg-[#229ED9]',
    hoverBg: 'hover:bg-[#1a8bbf]',
  },
  {
    key:     'social_instagram',
    label:   'Instagram',
    Icon:    InstagramIcon,
    bgColor: 'bg-gradient-to-br from-[#f9ce34] via-[#ee2a7b] to-[#6228d7]',
    hoverBg: 'hover:opacity-90',
  },
  {
    key:     'social_whatsapp',
    label:   'WhatsApp',
    Icon:    WhatsAppIcon,
    bgColor: 'bg-[#25D366]',
    hoverBg: 'hover:bg-[#1ebe5d]',
  },
];

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const [socialUrls, setSocialUrls] = useState({});

  useEffect(() => {
    api.get('/settings')
      .then(r => {
        const s = r.data || {};
        setSocialUrls({
          social_telegram:  s.social_telegram  || '',
          social_instagram: s.social_instagram || '',
          social_whatsapp:  s.social_whatsapp  || '',
        });
      })
      .catch(() => setSocialUrls({}));
  }, []);

  return (
    <footer className="bg-nutbrown-800 dark:bg-gray-950 text-white mt-auto">
      {/* Main footer */}
      <div className="container-main px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/logo.jpg" alt="Tinanzar" className="h-12 w-auto rounded-xl object-contain" />
              <span className="font-display font-bold text-2xl">
                Tinan<span className="text-brand-400">zar</span>
              </span>
            </Link>
            <p className="text-nutbrown-200 text-sm leading-relaxed mb-4">
              {t('footer.tagline')}
            </p>
            {/* Social links — loaded from DB settings */}
            {SOCIAL_CONFIG.some(cfg => socialUrls[cfg.key]) && (
              <div className="flex gap-3">
                {SOCIAL_CONFIG.filter(cfg => socialUrls[cfg.key]).map(({ key, label, Icon, bgColor, hoverBg }) => (
                  <a
                    key={key}
                    href={socialUrls[key]}
                    aria-label={label}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-9 h-9 rounded-full ${bgColor} ${hoverBg} flex items-center justify-center transition-all duration-200 text-white shadow-sm`}
                  >
                    <Icon />
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Shop */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.shop')}</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/products', label: t('nav.products') },
                { to: '/products?featured=true', label: '⭐ ' + t('products.featured') },
                { to: '/cart', label: t('nav.cart') },
              ].map(item => (
                <li key={item.to}>
                  <Link to={item.to} className="text-nutbrown-300 hover:text-white text-sm transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.company')}</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/about',   label: t('nav.about') },
                { to: '/blog',    label: t('nav.blog') },
                { to: '/contact', label: t('nav.contact') },
              ].map(item => (
                <li key={item.to}>
                  <Link to={item.to} className="text-nutbrown-300 hover:text-white text-sm transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-semibold text-white mb-4">{t('footer.support')}</h4>
            <ul className="space-y-2.5">
              {[
                { to: '/faq',     label: t('nav.faq') },
                { to: '/contact', label: t('contact.title') },
                { to: '/orders',  label: t('nav.orders') },
              ].map(item => (
                <li key={item.to}>
                  <Link to={item.to} className="text-nutbrown-300 hover:text-white text-sm transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>

            {/* Contact info */}
            <div className="mt-5 space-y-2">
              <p className="text-nutbrown-300 text-sm flex items-center gap-2">
                <span>📍</span> Calgary, Alberta, Canada
              </p>
              <p className="text-nutbrown-300 text-sm flex items-center gap-2">
                <span>📧</span> info@tinanzar.com
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-nutbrown-700 dark:border-gray-800">
        <div className="container-main px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-nutbrown-400 text-xs text-center">
            {t('footer.rights', { year })}
          </p>
          <div className="flex items-center gap-4">
            <span className="text-nutbrown-400 text-xs flex items-center gap-1">
              💰 {t('footer.currency_note')}
            </span>
            <span className="text-nutbrown-400 text-xs">{t('footer.canada_note')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
